import React from 'react';

// Utils
import { useClass } from '@breezerr';
import { usePartner } from '@brz-utils/contexts/partner.context';

// Components
import { Img } from './img';
import logo from '../../images/logo.svg';
import { Grow } from '@mui/material';

// Types
import type { PartnerDataModel } from '@brz-types/partner.data.model';
import { useBreakpoint } from '@brz-utils/contexts/is.breakpoint';
import { useGlobal } from '@brz-utils/contexts/global.context';
import type { QuoteProposalDataModel } from '@brz-components/sections/quote.proposal/section.quote.proposal';
import { useCoBranding } from '@brz-utils/contexts/cobrand.context';
import { useAgent } from '@brz-utils/contexts/agent.context';


type LogoProps = {
    src?: string;
    disablePartner?: boolean;
    displayName?: string;
    scale?: number;
};

const Logo = (props: LogoProps) => {
    const { isMobile } = useBreakpoint();
    const [show, setShow] = React.useState(false);

    const { coBrand } = useCoBranding();
    const { data: client } = useGlobal<QuoteProposalDataModel>('client');
    const { partner } = usePartner();
    const { agent } = useAgent();

    React.useEffect(() => {
        if ( isMobile ) return;

        if (props.disablePartner) {
            setTimeout(() => {
                setShow(props.displayName && !props.src ? true : false);
            }, 500);
        } else {
            setTimeout(() => {
                setShow(!!partner);
            }, 500);
        }
        
    }, [partner, props.displayName, props.src]);


    // Client data
    if ( (client?.firstName || client?.lastName) && !props.disablePartner ) {
        return <span className={useClass('d-flex align-items-center')}>
            <img className={useClass('d-block w-11.2rem h-2.3rem')} src={logo} width={112} height={23} alt="Breeze Logo" />
            <svg className={useClass('p-relative d-block top-0.3rem px-1rem')} xmlns="http://www.w3.org/2000/svg" width="12.505" height="12.506" viewBox="0 0 12.505 12.506">
                <g transform="translate(-312.299 -386.552) rotate(45)">
                    <path d="M0,3.01,3.01,0l3.01,3.01" transform="translate(503 55.514) rotate(-90)" fill="none" stroke="#233849" strokeLinecap="round" strokeWidth="2" />
                    <path d="M0,0,3.01,3.01,6.019,0" transform="translate(500 55.514) rotate(-90)" fill="none" stroke="#233849" strokeLinecap="round" strokeWidth="2" />
                </g>
            </svg>
            <span className={useClass('d-block')}>
                <span className={useClass('d-block text-size-2.6rem text-800 -ls-0.1rem text-color-primary! lh-3rem mt-0.6rem no-underline ws-nowrap')}>{ client.firstName } { client.lastName }</span>
            </span>
        </span>
    }


    // Agent
    if ( (agent?.firstName || agent?.lastName) && !props.disablePartner ) {
        return <span className={useClass('d-flex align-items-center')}>
            <img className={useClass('d-block w-11.2rem h-2.3rem')} src={logo} width={112} height={23} alt="Breeze Logo" />
            <svg className={useClass('p-relative d-block top-0.3rem px-1rem')} xmlns="http://www.w3.org/2000/svg" width="12.505" height="12.506" viewBox="0 0 12.505 12.506">
                <g transform="translate(-312.299 -386.552) rotate(45)">
                    <path d="M0,3.01,3.01,0l3.01,3.01" transform="translate(503 55.514) rotate(-90)" fill="none" stroke="#233849" strokeLinecap="round" strokeWidth="2" />
                    <path d="M0,0,3.01,3.01,6.019,0" transform="translate(500 55.514) rotate(-90)" fill="none" stroke="#233849" strokeLinecap="round" strokeWidth="2" />
                </g>
            </svg>
            <span className={useClass('d-block')}>
                <span className={useClass('d-block text-size-2.6rem text-800 -ls-0.1rem text-color-primary! lh-3rem mt-0.6rem no-underline ws-nowrap')}>{ agent.firstName } { agent.lastName }</span>
            </span>
        </span>
    }

    // CoBranding Data
    if ( !!coBrand && !props.disablePartner ) {
        return <span className={useClass('d-flex align-items-center')}>
            <img className={useClass('d-block w-11.2rem h-2.3rem')} src={logo} width={112} height={23} alt="Breeze Logo" />
            <svg className={useClass('p-relative d-block top-0.3rem px-1rem')} xmlns="http://www.w3.org/2000/svg" width="12.505" height="12.506" viewBox="0 0 12.505 12.506">
                <g transform="translate(-312.299 -386.552) rotate(45)">
                    <path d="M0,3.01,3.01,0l3.01,3.01" transform="translate(503 55.514) rotate(-90)" fill="none" stroke="#233849" strokeLinecap="round" strokeWidth="2" />
                    <path d="M0,0,3.01,3.01,6.019,0" transform="translate(500 55.514) rotate(-90)" fill="none" stroke="#233849" strokeLinecap="round" strokeWidth="2" />
                </g>
            </svg>
            <span className={useClass('d-block')}>
                <span className={useClass('d-block text-size-2.6rem text-800 -ls-0.1rem text-color-primary! lh-3rem mt-0.6rem no-underline ws-nowrap')}>{ coBrand.displayName }</span>
            </span>
        </span>
    }


    return !props.disablePartner && (partner && (partner.logo?.src || partner.displayName) || (props.displayName && !props.src)) ? (
        <span className={useClass('d-flex align-items-center')}>
            <img className={useClass('d-block w-11.2rem h-2.3rem')} src={logo} width={112} height={23} alt="Breeze Logo" />

            {show ? <div className={useClass('d-none md:d-flex align-items-center')}>
                <Grow in={show} timeout={300} appear unmountOnExit>
                    <svg className={useClass('p-relative d-block top-0.3rem px-1rem')} xmlns="http://www.w3.org/2000/svg" width="12.505" height="12.506" viewBox="0 0 12.505 12.506">
                        <g transform="translate(-312.299 -386.552) rotate(45)">
                            <path d="M0,3.01,3.01,0l3.01,3.01" transform="translate(503 55.514) rotate(-90)" fill="none" stroke="#233849" strokeLinecap="round" strokeWidth="2" />
                            <path d="M0,0,3.01,3.01,6.019,0" transform="translate(500 55.514) rotate(-90)" fill="none" stroke="#233849" strokeLinecap="round" strokeWidth="2" />
                        </g>
                    </svg>
                </Grow>

                <Grow in={show} timeout={400} appear unmountOnExit>
                    <span className={useClass('d-block')}>
                        {partner?.logo?.src ? (
                            <Img className={useClass('d-block')} {...partner.logo} quality={90} scale={0.5} />
                        ) : null}

                        {!partner?.logo?.src && (partner?.displayName || props.displayName) ? (
                            <span className={useClass('d-block text-size-2.6rem text-800 -ls-0.1rem text-color-primary! lh-3rem mt-0.6rem no-underline! ws-nowrap')}>{ partner?.displayName || props.displayName }</span>
                        ) : null}
                    </span>
                </Grow>
            </div> : null}

            {/* <Img className={useClass('d-none md:d-block')} src={partner.logo.src} quality={90} /> */}
            {/* {partner.mobileLogo ? (
                <Img className={useClass('d-block md:d-none')} src={partner.mobileLogo} quality={90} />
            ) : null} */}
        </span>
    ) : (
        props.src ? (
            <Img src={props.src} quality={90} scale={props.scale || 1} />
        ) : (
            <img className={useClass('w-11.2rem h-2.3rem -mb-0.5rem')} src={logo} width={112} height={23} alt="Breeze Logo" />
        )
    );
};

export default Logo;